import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


export class SkyTabButtonComponent {
  
  public tabHeading: string;

  
  public tabHeaderCount: number;

  
  public tabStyle: string;

  
  public active: boolean;

  
  public allowClose: boolean;

  
  public disabled: boolean;

  
  public tabClick = new EventEmitter<any>();

  
  public closeClick = new EventEmitter<any>();

  public doTabClick() {
    if (!this.disabled) {
      this.tabClick.emit(undefined);
    }
  }

  public doCloseClick() {
    this.closeClick.emit(undefined);
  }

  public keyDownFunction(event: any) {
    if (event.keyCode === 13) {
      this.doTabClick();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tab-button',
  template: `<a
    class="sky-btn-tab"
    [ngClass]="{
      'sky-btn-tab-wizard': tabStyle === 'wizard',
      'sky-btn-tab-selected': active,
      'sky-btn-tab-disabled': disabled,
      'sky-tab-btn-closeable': allowClose
    }"
    tabindex="0"
    (keydown)="keyDownFunction($event)"
    (click)="doTabClick()"
    role="tab"
    [attr.aria-selected]="active"
>
  {{tabHeading}}
  <span
    class="sky-tab-header-count"
    *ngIf="tabHeaderCount || tabHeaderCount === 0"
  >
    {{tabHeaderCount}}
  </span>
  <button
      type="button"
      class="sky-btn-tab-close"
      [attr.aria-label]="'tab_close' | skyResources"
      *ngIf="allowClose"
      (click)="doCloseClick();$event.stopPropagation()"
  >
    <i class="fa fa-remove"></i>
  </button>
</a>
`,
  styles: [`.sky-tab-button-close {
  color: #686c73;
  line-height: 1.4;
  margin-left: 5px;
}

.sky-tab-button-close:hover {
  color: #282b31;
  transition: color 150ms;
}

.sky-btn-tab-selected .sky-tab-button-close {
  color: #fff;
}

.sky-btn-tab.sky-tab-btn-closeable {
  padding-right: 10px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabHeading': [{ type: Input },],
'tabHeaderCount': [{ type: Input },],
'tabStyle': [{ type: Input },],
'active': [{ type: Input },],
'allowClose': [{ type: Input },],
'disabled': [{ type: Input },],
'tabClick': [{ type: Output },],
'closeClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
